import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { useState, useEffect } from "react";
import "./styles.scss";
import SmallFont from "../../common/SmallFont";
import { useLocation } from "react-router";
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const CalendarV2 = (props) => {
    const [curOrderDate, setCurOrderDate] = useState("");
    const [firstDay, setFirstDay] = useState("");
    const [daysInMonth, setDaysInMonth] = useState("");
    const [lastDay, setLastDay] = useState("");
    const [visibleMonth, setVisibleMonth] = useState("");
    const [visibleYear, setVisibleYear] = useState("");
    const [canGoBack, setCanGoBack] = useState(true);
    const [canGoForward, setCanGoForward] = useState(true);
    const { pathname } = useLocation();
    function initializeCal(newYear, newMonth) {
        setVisibleMonth(newMonth);
        setVisibleYear(newYear);
        setFirstDay(new Date(newYear, newMonth).getDay());
        setDaysInMonth(32 - new Date(newYear, newMonth, 32).getDate());
        setLastDay(new Date(newYear, newMonth).getDay() +
            (32 - new Date(newYear, newMonth, 32).getDate()));
    }
    function getAbleToGoForward(year, month) {
        if (props.maxDate != null) {
            if (props.maxDate.getMonth() <= Number(month)) {
                if (props.maxDate.getFullYear() <= Number(year)) {
                    return false;
                }
            }
        }
        return true;
    }
    function getAbleToGoBack(year, month) {
        if (props.minDate != null) {
            if (props.minDate.getMonth() >= Number(month)) {
                if (props.minDate.getFullYear() >= Number(year)) {
                    return false;
                }
            }
        }
        return true;
    }
    function previousMonth() {
        const month = visibleMonth;
        let newMonth = 0;
        let newYear = 0;
        if (month === 0) {
            newMonth = 11;
            newYear = Number(visibleYear) - 1;
        }
        else {
            newMonth = Number(month) - 1;
            newYear = Number(visibleYear);
        }
        const abletogoback = getAbleToGoBack(newYear, newMonth);
        setCanGoBack(abletogoback);
        const abletogoforward = getAbleToGoForward(newYear, newMonth);
        setCanGoForward(abletogoforward);
        initializeCal(newYear, newMonth);
    }
    function nextMonth() {
        const month = visibleMonth;
        let newMonth = 0;
        let newYear = 0;
        if (month === 11) {
            newMonth = 0;
            newYear = Number(visibleYear) + 1;
        }
        else {
            newMonth = Number(month) + 1;
            newYear = Number(visibleYear);
        }
        const abletogoback = getAbleToGoBack(newYear, newMonth);
        setCanGoBack(abletogoback);
        const abletogoforward = getAbleToGoForward(newYear, newMonth);
        setCanGoForward(abletogoforward);
        initializeCal(newYear, newMonth);
    }
    function selectDate(e) {
        const target = e.target;
        const day = target.innerText;
        const newDate = new Date(Number(visibleYear), Number(visibleMonth), Number(day));
        setCurOrderDate(newDate);
        props.callBack(newDate);
    }
    let day = 0;
    useEffect(() => {
        const abletogoback = getAbleToGoBack(props.year, props.month);
        setCanGoBack(abletogoback);
        const abletogoforward = getAbleToGoForward(props.year, props.month);
        setCanGoForward(abletogoforward);
        setCurOrderDate(new Date(props.year, props.month, props.day));
        initializeCal(props.year, props.month);
    }, []);
    const isMemberperk = pathname.indexOf("memberperk") > -1;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "fully-spaced-row calendar-v2-wrapper", style: {
                    maxWidth: "280px",
                    margin: "30px auto 15px auto",
                    lineHeight: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "95%",
                }, children: [_jsx("span", { onKeyPress: () => null, tabIndex: 0, role: "button", className: `arrow noselect ${canGoBack ? "" : "disabled"}`, onClick: previousMonth, id: "prevMonthBtn", children: "\u276E" }), _jsxs("span", { className: "card-header", id: "monthAndYear", style: { fontSize: "23px" }, children: [months[visibleMonth], " ", visibleYear] }), _jsx("span", { className: `arrow noselect ${canGoForward ? "" : "disabled"}`, onClick: nextMonth, id: "nextMonthBtn", onKeyPress: () => null, tabIndex: 0, role: "button", children: "\u276F" })] }), _jsx("div", { className: "separator" }), _jsxs("table", { cellSpacing: "0", cellPadding: "0", className: "table table-bordered table-responsive-sm noselect calendar-v2", id: "calendar-v2", children: [_jsxs("thead", { children: [_jsxs("tr", { className: "daysofweek", children: [_jsx("th", { children: "S" }), _jsx("th", { children: "M" }), _jsx("th", { children: "T" }), _jsx("th", { children: "W" }), _jsx("th", { children: "TH" }), _jsx("th", { children: "FR" }), _jsx("th", { children: "S" })] }), [0, 1, 2, 3, 4, 5].map((row) => (_jsx("tr", { className: "board-row", children: [0, 1, 2, 3, 4, 5, 6].map((col) => {
                                    if ((row === 0 && col < Number(firstDay)) ||
                                        day >= Number(daysInMonth)) {
                                        return _jsx("td", { className: "invalid-date" }, col);
                                    }
                                    day++;
                                    const temp_date = new Date(Number(visibleYear), visibleMonth, day);
                                    if (props.minDate != null && props.minDate > temp_date) {
                                        return (_jsx("td", { className: "invalid-date", children: _jsx(SmallFont, { color: "rgba(0, 0, 0, 0.4)", fontWeight: 400, children: day }) }, col));
                                    }
                                    if (props.maxDate != null && props.maxDate < temp_date) {
                                        return (_jsx("td", { className: "invalid-date", children: _jsx(SmallFont, { color: "rgba(0, 0, 0, 0.4)", fontWeight: 400, children: day }) }, col));
                                    }
                                    return (_jsx("td", { role: "button", className: `${isMemberperk ? "valid-date-blue" : "valid-date"} ${temp_date.getTime() === curOrderDate.getTime()
                                            ? "date-selected"
                                            : null}`, onClick: selectDate, onKeyPress: () => null, tabIndex: 0, children: _jsx(SmallFont, { color: temp_date.getTime() === curOrderDate.getTime()
                                                ? "#fff"
                                                : "#333", fontWeight: 400, children: day }) }, col));
                                }) }, row)))] }), _jsx("tbody", { id: "calendar-body" })] })] }));
};
export default CalendarV2;
